import { Stack, Typography, useTheme } from "@mui/material";

import { RHFUploadImage } from "@app/components";
import { Strings } from "@app/constants";

const Images = ({ methods }: any) => {
  const theme = useTheme();
  return (
    <>
      <Stack flexDirection={"column"} py={2}>
        <Stack
          sx={{
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <Typography
            sx={{
              fontSize: 24,
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            {Strings.step.carInfo.tellUsAboutYourCar}
          </Typography>
          <Typography
            variant="body1"
            sx={{ color: theme.palette.grey[500], textAlign: "center" }}
          >
            {Strings.step.carInfo.fillInYourCarsDetails}
          </Typography>
        </Stack>
      </Stack>
      <Stack
        flexDirection={"row"}
        gap={2}
        flexWrap={"wrap"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <RHFUploadImage
          name={`image.frontView`}
          label={Strings.step.images.frontView}
        />
        <RHFUploadImage
          name={`image.backView`}
          label={Strings.step.images.backView}
        />
        <RHFUploadImage
          name={`image.leftSideView`}
          label={Strings.step.images.leftSideView}
        />
        <RHFUploadImage
          name={`image.rightSideView`}
          label={Strings.step.images.rightSideView}
        />
        <RHFUploadImage
          name={`image.interiorDashboard`}
          label={Strings.step.images.interiorDashboard}
        />
        <RHFUploadImage
          name={`image.odometerReading`}
          label={Strings.step.images.odometerReading}
        />
      </Stack>
      {(methods.formState.errors?.image?.frontView || methods.formState.errors?.image) && (
        <Typography color="error" textAlign="center" mt={2} fontWeight={600}>
          {methods.formState.errors?.image?.frontView?.message || "Front view image is required"}
        </Typography>
      )}
    </>
  );
};

export { Images };
